import { render, staticRenderFns } from "./authDetail.vue?vue&type=template&id=0efd35e6&scoped=true"
import script from "./authDetail.vue?vue&type=script&lang=ts"
export * from "./authDetail.vue?vue&type=script&lang=ts"
import style0 from "./authDetail.vue?vue&type=style&index=0&id=0efd35e6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0efd35e6",
  null
  
)

export default component.exports